// export const MINDMAP_MIN_ZOOM = 0.25;
// export const MINDMAP_MAX_ZOOM = 2.0;

export const TimelineZoomLimits = {
  Billion: 0,
  Million: 1,
  Thousand: 2,
  Century: 3,
  Decade: 4,
  Year: 5,
  Month: 6,
  Week: 7,
  Day: 8,
  Hour: 9,
  Minute: 10,
  Second: 11
};

export const zoomLimits = [
  TimelineZoomLimits.Billion,
  TimelineZoomLimits.Million,
  TimelineZoomLimits.Thousand,
  TimelineZoomLimits.Century,
  TimelineZoomLimits.Decade,
  TimelineZoomLimits.Year,
  TimelineZoomLimits.Month,
  TimelineZoomLimits.Week,
  TimelineZoomLimits.Day,
  TimelineZoomLimits.Hour,
  TimelineZoomLimits.Minute,
  TimelineZoomLimits.Second
];

export const labelForZoomLimit = zoomLimit => {
  switch (zoomLimit) {
    case TimelineZoomLimits.Billion:
      return "Billion Years";
    case TimelineZoomLimits.Million:
      return "Million Years";
    case TimelineZoomLimits.Thousand:
      return "Millenia";
    case TimelineZoomLimits.Century:
      return "Centuries";
    case TimelineZoomLimits.Decade:
      return "Decades";
    case TimelineZoomLimits.Year:
      return "Years";
    case TimelineZoomLimits.Month:
      return "Months";
    case TimelineZoomLimits.Week:
      return "Weeks";
    case TimelineZoomLimits.Day:
      return "Days";
    case TimelineZoomLimits.Hour:
      return "Hours";
    case TimelineZoomLimits.Minute:
      return "Minutes";
    case TimelineZoomLimits.Second:
      return "Seconds";
  }
};
